import React, { useCallback, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import Tabs from "../../widgets/tabs";
import LoaderTrans from "../../widgets/loadertrans";
import ErrorCard from "../../widgets/error";
import { ERROR_MESSAGE } from "../../constants/dialog.constants";
import InvoiceCardList from "../../widgets/invoicing_list";
import {
  BENCHMARK_INVOICING_LIST,
  BENCHMARK_INVOICING_PRINT,
  UPFLOW_URL,
} from "../../constants/app.constants";
import {
  fetchBenchmarkInvoicingList,
  printBenchmarkInvoice,
} from "../invoicing/invoicing.utils";
const tabData = [
  {
    label: "Overview",
    path: "Overview",
  },
  {
    label: "Client Connection",
    path: "ClientConnection",
  },
  {
    label: "Invoicing",
    path: "Invoicing"
  },
  {
    label: "Scheduling",
    path: "Scheduling",
  },
  {
    label: "Quotes",
    path: "Quotes"
  },
];

const Invoicing: React.FC = () => {
  const [printInvoiceFlag, setPrintInvoiceFlag] = useState(false);
  const [invoiceId, setInvoiceId] = useState(0);
    //NEW
  const [iframeUrl, setIframeUrl] = useState("");

  const printInvoice = useCallback(
    (id: number) => {
      setInvoiceId(id);
      setPrintInvoiceFlag(true);
    },
    [invoiceId]
  );

  const {
    isLoading: isLoadingBenchmarkInvoicingList,
    error: errorBenchmarkInvoicingList,
    data: dataBenchmarkInvoicingList,
  } = useQuery({
    queryKey: [BENCHMARK_INVOICING_LIST],
    //queryFn: () => fetchBenchmarkInvoicingList(localStorage.getItem("ID")),
    queryFn: fetchBenchmarkInvoicingList,
    refetchOnWindowFocus: false,
  });

  const buttonsClass: ButtonProps[] = [
    {
      btnClassName: "tn btn-sm requestChangeBtn",
      btnName: "Print",
    },
  ];

  const {
    isLoading: isLoadingBenchmarkInvoicePrint,
    error: errorBenchmarkInvoicePrint,
    data: dataBenchmarkInvoicePrint,
    isFetching: isFetchingBenchmarkInvoicePrint,
  } = useQuery({
    queryKey: ["BENCHMARK_INVOICING_PRINT"],
    queryFn: () => printBenchmarkInvoice(localStorage.getItem("ID"), invoiceId),
    enabled: printInvoiceFlag,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    setInvoiceId(0);

    !isLoadingBenchmarkInvoicePrint &&
    dataBenchmarkInvoicePrint != undefined &&
    !isFetchingBenchmarkInvoicePrint &&
    printInvoiceFlag
      ? window.open(dataBenchmarkInvoicePrint, "_blank")
      : null;
    if (dataBenchmarkInvoicePrint != undefined) {
      setPrintInvoiceFlag(false);
    }
  }, [dataBenchmarkInvoicePrint, isLoadingBenchmarkInvoicePrint]);


  //NEW
useEffect(() => {
  const fetchIframeUrl = async () => {
    const quickbookId = window.localStorage.getItem("Intake_QuickbooksAccount");

    if (!quickbookId) {
      console.error("Quickbook ID not found in localStorage.");
      return;
    }

 try {
  const response = await fetch(
    `${UPFLOW_URL}/api/controller/upflowIntegration.php`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ quickbookId }),
    }
  );

  const data = await response.json();
  console.log("Response from PHP:", data);

  if (data?.url) {
    setIframeUrl(data.url);
  } else {
    console.error("No URL returned from server.");
  }
} catch (error) {
  console.error("Failed to fetch iframe URL:", error);
}
  };

  fetchIframeUrl();
}, []);
 

 return (
    <>
      <div className="container-fluid">
        <div className="body-content">
          <Tabs tabs={tabData} activeTabIndex={2} />

          {isLoadingBenchmarkInvoicingList && <LoaderTrans msg="Loading" />}
          {errorBenchmarkInvoicingList && <ErrorCard msg={ERROR_MESSAGE} />}
          {(isLoadingBenchmarkInvoicePrint || isFetchingBenchmarkInvoicePrint) && (
            <LoaderTrans loaderClassName="loaderCenterList" msg="Loading" />
          )}
          {errorBenchmarkInvoicePrint && <ErrorCard msg={ERROR_MESSAGE} />}

          {iframeUrl ? (
            <iframe
              src={iframeUrl}
              title="Upflow Portal"
              style={{
                width: "100%",
                height: "600px",
                border: "none",
              }}
            />
          ) : (
            // <p>Loading portal...</p>
            null
          )}
        </div>
      </div>
    </>


   
  );
};

export default Invoicing;
